import { render, staticRenderFns } from "./milestone-category-navigation.vue?vue&type=template&id=f7b3efca&scoped=true&"
import script from "./milestone-category-navigation.vue?vue&type=script&lang=ts&"
export * from "./milestone-category-navigation.vue?vue&type=script&lang=ts&"
import style0 from "./milestone-category-navigation.vue?vue&type=style&index=0&id=f7b3efca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b3efca",
  null
  
)

export default component.exports